import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { headersBase } from "../../../utils/constants/headersForApi";

export const userCategoriesApi = createApi({
  reducerPath: "userCategories",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  endpoints: (builder) => ({
    getUserCategories: builder.query({
      query: () => ({
        url: "/data/maincategories",
        method: "GET",
        headers: headersBase(),
      }),
    }),
  }),
});

export const { useGetUserCategoriesQuery } = userCategoriesApi;
